<template>
  <a-drawer
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :closable="true"
    :headerStyle="{paddingTop:'0px',background:'#F4F9FD'}"
    :bodyStyle="{background:'#F4F9FD',padding: 0 }"
    :drawerStyle="{background:'#F4F9FD'}"
    @close="handleCancel"
    cancelText="关闭">
    <div class="model-top">
      创建工单
    </div>
    <dm-work-order-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit" normal></dm-work-order-form>
    <div class="drawer-footer">
      <a-button @click="handleCancel" style="margin-bottom: 0;">关闭</a-button>
      <a-button  @click="handleOk"   type="primary" style="margin-bottom: 0;">确定</a-button>
    </div>
  </a-drawer>
</template>

<script>

  import DmWorkOrderForm from './DmWorkOrderForm'
  import { httpAction, getAction,getFileAccessHttpUrl } from '@/api/manage'

  export default {
    name: 'DmWorkOrderModal',
    components: {
      DmWorkOrderForm
    },
    data () {
      return {
        title:"新建工单",
        width:400,
        visible: false,
        disableSubmit: false,
      }
    },created(){

    },
    methods: {
      add (arr) {
        this.disableSubmit = false;
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.add(arr);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },handleCancel(){
        this.close()
      },submitCallback(workOrderId){
        this.$emit('ok',workOrderId);
        this.visible = false;
      }
    }
  }
</script>

<style lang="less" scoped>
/** Button按钮间距 */
.model-top{
  height: 48px;
  line-height: 48px;
  color: #0A1629;
  font-size: 16px;
  background:#F4F9FD;
  padding-left: 24px;
  border-bottom: 1px solid #E6EDF5;
}
.top-bg0{
  background: #F4F9FD;
}
.drawer-footer .ant-btn {
  margin-left: 30px;
  margin-bottom: 30px;
  float: right;

}
.drawer-footer{
  justify-content: center;
  display: flex;
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: center;
  left: 0;
  border-radius: 0 0 2px 2px;
  background: #F4F9FD;
}
/deep/ .ant-drawer-body{
  padding: 0 !important;
}
/deep/ .ant-modal-footer{
  text-align: center !important;
}


/deep/ .ant-drawer-content::-webkit-scrollbar-thumb{
  background: #E6EDF5 !important; /* 滑块颜色（可选搭配） */
  border-radius: 4px!important;
}

/deep/ .ant-drawer-content::-webkit-scrollbar-thumb:hover {
  background: #E6EDF5 !important; /* 滑块颜色（可选搭配） */
}

</style>